import {Button, Card, CardActionArea, CardContent, CircularProgress, Stack, Typography} from "@mui/material";
import {tcsBlueGray1} from "../../mui/Theme";
import React, {useEffect, useState} from "react";
import {useRouter} from "../../context/RouterContext";
import {useAuth} from "../../context/AuthContext";
import {collection, getCountFromServer, query, where} from "firebase/firestore";
import {firestore} from "../../config/firebase";
import {UserType} from "../../utils/model/UserType";

export default function AdminDashboard() {
    const {navigate} = useRouter();
    const {logout} = useAuth();

    const [flaggedCount, setFlaggedCount] = useState<number | null>(null);
    const [removedStationsCount, setRemovedStationsCount] = useState<number | null>(null);

    useEffect(() => {
        (async () => {
            try {
                const flaggedSnap = await getCountFromServer(query(
                    collection(firestore, "profiles"),
                    where("type", "in", [UserType.SUSPECT, UserType.SPAMMER])
                ));
                setFlaggedCount(flaggedSnap.data().count);
            } catch (e) {
                console.error(e);
                setFlaggedCount(null);
            }
        })();

        (async () => {
            try {
                const removedSnap = await getCountFromServer(query(
                    collection(firestore, "stations"),
                    where("isDeleted", "==", true)
                ));
                setRemovedStationsCount(removedSnap.data().count);
            } catch (e) {
                console.error(e);
                setRemovedStationsCount(null);
            }
        })();
    }, []);

    const onLogout = () => {
        logout();
        navigate('/');
    }

    const StatCard = ({label, value, onClick}: {label: string; value: number | null; onClick: () => void}) => (
        <Card sx={{flex: 1, minWidth: 180}}>
            <CardActionArea onClick={onClick}>
                <CardContent>
                    <Typography variant="h3" color="secondary">
                        {value === null ? <CircularProgress size={24}/> : value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {label}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );

    return (
        <>
            <Stack direction='column' height={'100%'}>
                <Stack sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                }}>
                    <h2>Admin Dashboard</h2>
                </Stack>

                <Stack direction="row" gap={2} sx={{padding: 2, flexWrap: "wrap"}}>
                    <StatCard
                        label="Flagged users"
                        value={flaggedCount}
                        onClick={() => navigate("/admin/user/flagged")}/>
                    <StatCard
                        label="Removed stations"
                        value={removedStationsCount}
                        onClick={() => navigate("/admin/station/removed")}/>
                </Stack>

                <Stack sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: '5px',
                    background: tcsBlueGray1,
                    padding: 2,
                    margin: 2
                }}>
                    <h3>Users</h3>
                    <Stack sx={{
                        flexDirection: "row",
                        gap: 1
                    }}>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={() => navigate("/admin/user/find")}
                        >
                            {"Find an user"}
                        </Button>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={() => navigate("/admin/user/flagged")}
                        >
                            {"Flagged users"}
                        </Button>
                    </Stack>
                </Stack>
                <Stack sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: '5px',
                    background: tcsBlueGray1,
                    padding: 2,
                    margin: 2
                }}>
                    <h3>Stations</h3>
                    <Stack sx={{
                        flexDirection: "row",
                        gap: 1
                    }}>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={() => navigate("/admin/station/find")}
                        >
                            {"Find a station"}
                        </Button>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={() => navigate("/admin/station/create")}
                        >
                            {"Create station"}
                        </Button>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={() => navigate("/admin/station/removed")}
                        >
                            {"Fuels and stations removed"}
                        </Button>
                    </Stack>
                </Stack>
                <Stack sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: '5px',
                    background: tcsBlueGray1,
                    padding: 2,
                    margin: 2
                }}>
                    <Stack sx={{
                        flexDirection: "row",
                        gap: 1
                    }}>
                        <Button
                            variant="contained"
                            type="button"
                            onClick={onLogout}
                        >
                            {"Logout"}
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </>
    )
}
